// extracted by mini-css-extract-plugin
export default {"selector":"SubscriptionMarketSelector_selector__ItyFM"};